import axios from "axios";
import React from "react";

import OtpInput from "react-otp-input";
import { useLocation } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import BZLogo from "../../components/BZLogo";
import { TwMainLayout } from "../../components/tailwind";
import { classNames } from "../../helpers";
import { useToast } from "../../provider/ToastProvider";
import { loadingState, setActionLoading, setGlobalLoading } from "../../redux/reducers/loadingReducer";
import { getUrlForUsers } from "../../utils/confighelpers";
import { useTenant } from "../../provider/TenantProvider";
import AuthShell, { AuthHeading, PrimaryAuthButton, StepBar } from "../../components/auth/AuthShell";
import { defaultDomainList } from "../../utils/constants";

export default function Verify({ navigation }) {
  const { addToast, addSuccessToast, addErrorToast } = useToast();
  const { tenant, tenantData, tenantLoading } = useTenant();
  const club = defaultDomainList.indexOf(tenant) < 0 && tenantData?.business_details ? tenantData.business_details : null;
  const location = useLocation();
  const dispatch = useDispatch();
  const loadingReduxState = useSelector(loadingState);
  const [otp, setOtp] = React.useState("");
  const [error, setError] = React.useState(false);
  const [submitting, setSubmitting] = React.useState(false);
  const [resendSMSSubmitting, setResendSMSSubmitting] = React.useState(false);
  const [numberToken, setNumberToken] = React.useState(
    location?.state?.response?.data?.token
  );

  const handleChange = (text) => setOtp(text);

  const handleResendSMS = async () => {
    setResendSMSSubmitting(true);
    dispatch(setActionLoading(true));
    dispatch(setGlobalLoading(true));
    const request = await axios.post(
      `${getUrlForUsers()}forgotPassword`,
      {
        username: location.state.countryCode + location.state.phone,
        userType: location.state.userType || "teacher",
      }
    );
    dispatch(setActionLoading(false));
    dispatch(setGlobalLoading(false));
    if (request.data.statusCode === 200) {
      setResendSMSSubmitting(false);
      setNumberToken(request.data.data.token);
      addSuccessToast(request.data.message);
    } else {
      setResendSMSSubmitting(false);
      addErrorToast(request.data.message);
    }
  };

  const handleWrongNumber = () => {
    navigation(-1, {
      state: {
        formattedPhoneNumber: location.state.formattedPhoneNumber,
        countryName: location.state.countryName,
        countryCode: location.state.countryCode,
        phone: location.state.phone,
      },
    });
  };

  const handleSubmit = async () => {

    setError(false);
    if (otp === "") {
      setError(true);
      return false
    }
    setSubmitting(true);
    dispatch(setActionLoading(true));

    const request1 = await axios.put(
      `${getUrlForUsers()}verifyForgotPasswordOtp`,
      {
        code: otp,
        token: numberToken,
      }
    );
    dispatch(setActionLoading(false));

    if (request1.data.statusCode === 200) {
      navigation("/forgot-password/reset", {
        state: { verified: true, token: request1.data.data.token },
      });
    } else {
      addErrorToast(request1.data.message);
      setSubmitting(false);
      setError(true);
      return;
    }
  };

  if (!location.state) {
    navigation("/");
  }

  return (
    <TwMainLayout fullScreen={true} checkSession={false}>
      <AuthShell club={club} brandTitle="Locked out?" brandLine="We text a code to your mobile, you pick a new password.">
        {location.state && (<div className="flex flex-col gap-6">
          <StepBar step={2} />
          <AuthHeading title="Enter the code" />
          <p className="-mt-4 text-base text-gray-600 sm:text-[17px]">
            We sent a 4-digit code to <span className="whitespace-nowrap font-extrabold text-gray-900">{location?.state?.formattedPhoneNumber}</span>.
          </p>
          <div className={"flex flex-col gap-5"}>
            <OtpInput
              value={otp}
              onChange={handleChange}
              numInputs={4}
              containerStyle={`flex gap-3`}
              inputStyle={classNames(`!h-[68px] !w-16 text-[28px] font-black text-gray-900 rounded-2xl bg-[#F5F4F6] outline outline-1 -outline-offset-1 focus-within:bg-white focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2`,
                error ? "text-red-900 outline-red-300 placeholder:text-red-300 focus-within:outline-red-600"
                  : "text-gray-900 outline-gray-300 placeholder:text-gray-400 hover:outline-indigo-bz focus-within:outline-indigo-bz"
              )}
              renderInput={(props) => <input {...props} />}
              hasErrored={error}
              shouldAutoFocus
              inputType="number"
            />
            <p className="text-[15px] text-gray-600">
              Didn't get it?{" "}
              <button type="button" className="font-extrabold text-indigo-bz hover:underline disabled:opacity-50" onClick={handleResendSMS} disabled={resendSMSSubmitting}>
                Send again
              </button>
              {" · "}
              <button type="button" className="font-extrabold text-indigo-bz hover:underline" onClick={handleWrongNumber}>
                Change number
              </button>
            </p>
            <PrimaryAuthButton type="button" onClick={handleSubmit} busy={loadingReduxState.actionLoading || submitting}>Verify code</PrimaryAuthButton>
          </div>
        </div>)}
      </AuthShell>
    </TwMainLayout>)
}
